export default "__VITE_ASSET__CbOrRK$5__"